import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from '../paths';
import { PageRoute } from '../types';

export const ordersRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/orders/pages/OrdersPage')),
    path: ROUTES.AUTHORIZED.ORDERS,
    title: 'Orders',
  },
  {
    component: asyncComponentLoader(() => import('@/features/orders/pages/OrderPage')),
    path: `${ROUTES.AUTHORIZED.ORDERS}/:id?`,
    title: 'Order',
  },
  {
    component: asyncComponentLoader(() => import('@/features/orders/pages/OrderPage')),
    path: `${ROUTES.AUTHORIZED.ORDERS}/:id/invoices/:invoiceId/edit`,
    title: 'Order',
  },
];
